module.exports = __webpack_public_path__ + "static/media/prof experience-01-01.4cf76a4f.svg";